webpackJsonp([188576960677120],{

/***/ 311:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>If you're developing with electron on macOS and clicking the fullscreen button (or 'Enter Full Screen') makes a <strong>BUMP</strong> noise, check if you're launching it through <code>tmux</code> or <code>screen</code>. For... <a href=\"https://github.com/electron/electron/issues/2599\">reasons</a>... this doesn't work out of the box. A quick fix is to launch the dev process directly from your shell - I use a separate tab for this since I'm a tmux addict, but you can also use the <a href=\"https://www.iterm2.com/documentation-one-page.html#documentation-highlights.html\">splits feature</a> of iTerm2 to manage it.</p>","frontmatter":{"permalink":"electron-fullscreen-not-working","title":"Fullscreen not working on macOS with Electron","date":"2017-12-31","tags":["electron","macos","js"]}}},"pathContext":{"permalink":"electron-fullscreen-not-working"}}

/***/ })

});


// WEBPACK FOOTER //
// path---electron-fullscreen-not-working-703aee53a2df7af86ed3.js